import React from 'react';

export const VkLogoIcon = () => (
  <svg
    style={{ verticalAlign: 'top', color: 'var(--text-primary)', marginRight: 'var(--space-200)' }}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.375 11.655C3.375 7.75177 3.375 5.80016 4.58758 4.58758C5.80016 3.375 7.75177 3.375 11.655 3.375H12.345C16.2482 3.375 18.1998 3.375 19.4124 4.58758C20.625 5.80016 20.625 7.75177 20.625 11.655V12.345C20.625 16.2482 20.625 18.1998 19.4124 19.4124C18.1998 20.625 16.2482 20.625 12.345 20.625H11.655C7.75177 20.625 5.80016 20.625 4.58758 19.4124C3.375 18.1998 3.375 16.2482 3.375 12.345V11.655Z"
      stroke="var(--i-color)"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5201 15.5235C8.87112 15.5235 6.78985 13.022 6.70312 8.85938H8.53093C8.59096 11.9146 9.93844 13.2087 11.0058 13.4756V8.85938H12.7269V11.4943C13.7809 11.3809 14.8881 10.1802 15.2617 8.85937H16.9828C16.696 10.4871 15.4952 11.6878 14.6413 12.1814C15.4952 12.5817 16.8628 13.629 17.3831 15.5235H15.4886C15.0816 14.2561 14.0677 13.2755 12.7269 13.142V15.5235H12.5201Z"
      fill="var(--i-color)"
    />
  </svg>
);
